import Vue from 'vue';
import VueI18n from 'vue-i18n'
import en from './langs/en'
import zh from './langs/zh'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 注册 i18n 插件
Vue.use(VueI18n);
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});

// 1. 从本地存储获取语言（持久化，刷新不丢失）
const lang = localStorage.getItem('language') || 'zh'

// 2. 定义语言包映射
const messages = {
  en,
  zh
}

// 3. 创建 i18n 实例
const i18n = new VueI18n({
    locale: lang,        // 默认语言
    fallbackLocale: 'zh', // 语言匹配失败时的兜底语言
    messages             // 语言包
})

export default i18n
